export default __webpack_public_path__ + "static/media/runIconSemSobra.e2959418.svg";